<i [class]="this.icon" (click)="deletePackageSchedule(order)">
</i>
